import React from 'react';
import createReactClass from 'create-react-class';
import config from './config/shipmentsConfig';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import { Form, AdornedInput, Input } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var NewShipment = createReactClass({

  componentWillMount() {
    setViewTitle('Wareneingangsdokument');
  },

  getInitialState() {
    return {
      lines: [],
      newLines: [],
    };
  },

  componentDidMount() {
    request.get({
      url: config.apiUrl + 'new/' + this.props.match.params.purchaseOrderId,
      success: shipment => {
        if (this.isMounted()) {
          if (!shipment.hasBeenSaved) {
            shipment.lines.forEach(x => x.stockUnitQuantity = Math.max(0, x.orderedStockUnitQuantity - x.deliveredStockUnitQuantity));
            shipment.newLines.forEach(x => x.stockUnitQuantity = Math.max(0, x.orderedStockUnitQuantity - x.deliveredStockUnitQuantity));
          }

          this.setState(
            shipment
          );
        }
      }
    });
  },

  handleSubmit() {
    var shipment = this.form.getModel();
    this.submit(shipment, false);
  },

  handleSubmitAndClosePurchaseOrder() {
    var shipment = this.form.getModel();
    this.submit(shipment, true);
  },

  submit(shipment, closePreparation) {
    shipment.id = this.state.id;
    shipment.orderId = this.state.orderId;
    shipment.closePreparation = closePreparation;

    request.post({
      url: config.apiUrl + 'prepare',
      data: shipment,
      success: () => {
        this.props.history.push('/purchaseorders/ordered/overview');
      }
    });
  },

  render() {
    var displayLines = this.state.lines.map((line, index) => (
      <tr key={index}>
        <td className="col-md-2">{line.itemName}</td>
        <td className="col-md-1">{line.stockUnitName}</td>
        <td className="col-md-1">{line.orderedStockUnitQuantity}</td>
        <td className="col-md-1">{line.deliveredStockUnitQuantity}</td>
        <td className="col-md-1">
          <Input name={`lines[${index}].itemId`} type="hidden" required value={line.itemId} />
          <Input name={`lines[${index}].orderedStockUnitQuantity`} type="hidden" required value={line.orderedStockUnitQuantity} />
          <Input name={`lines[${index}].deliveredStockUnitQuantity`} type="hidden" required value={line.deliveredStockUnitQuantity} />
          <Input name={`lines[${index}].storageLocationId`} type="hidden" required value={line.storageLocationId} />

          <AdornedInput
            layout="elementOnly"
            name={`lines[${index}].stockUnitQuantity`}
            id={`lines[${index}].stockUnitQuantity`}
            type="number"
            value={line.stockUnitQuantity}
            validations="isMoreThan:-1"
            required
          />
        </td>
      </tr>
    ));

    var displayNewLines = this.state.newLines.map((line, index) => (
      <tr key={index}>
        <td className="col-md-2">
          {line.itemName}
        </td>
        <td className="col-md-1">{line.stockUnitName}</td>
        <td className="col-md-1">{line.orderedStockUnitQuantity}</td>
        <td className="col-md-1">{line.deliveredStockUnitQuantity}</td>
        <td className="col-md-1">
          <Input name={`newLines[${index}].itemName`} type="hidden" required value={line.itemName} />
          <Input name={`newLines[${index}].stockUnitName`} type="hidden" value={line.stockUnitName} />
          <Input name={`newLines[${index}].orderedStockUnitQuantity`} type="hidden" required value={line.orderedStockUnitQuantity} />
          <Input name={`newLines[${index}].deliveredStockUnitQuantity`} type="hidden" required value={line.deliveredStockUnitQuantity} />

          <AdornedInput
            layout="elementOnly"
            name={`newLines[${index}].stockUnitQuantity`}
            id={`newLines[${index}].stockUnitQuantity`}
            type="number"
            value={line.stockUnitQuantity}
            validations="isMoreThan:-1"
            required
          />
        </td>
      </tr>
    ));

    const disableSubmit =
      !this.state.isValid ||
      this.props.isAjaxInProgress;

    const footer = (
      <footer>
        <button type="button" className="btn btn-primary" onClick={this.handleSubmit} disabled={disableSubmit}>Speichern</button>
        <button type="button" className="btn btn-success" onClick={this.handleSubmitAndClosePurchaseOrder} disabled={disableSubmit}>Speichern und abschließen</button>
      </footer>
    );

    return (
      <SimplePage title="Wareneingangsdokument">
        <Form ref={c => this.form = c}
          onValid={() => this.setState({isValid: true})}
          onInvalid={() => this.setState({isValid: false})}
          footer={footer}>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Artikel</th>
                  <th>Basiseinheit</th>
                  <th>Bestellmenge</th>
                  <th>Bereits geliefert</th>
                  <th>Liefermenge</th>
                </tr>
              </thead>
              <tbody>
                  {displayLines}
                  {displayNewLines}
              </tbody>
            </table>
          </div>
        </Form>
      </SimplePage>
    );
  }
});

export default AjaxInProgressHOC(NewShipment);



// WEBPACK FOOTER //
// ./src/components/shipments/NewShipment.js